import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { AuthProvider } from './contexts/AuthContext';
import Login from './components/login/login-component';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import SearchComponent from './pages/search/search-component/search-component';
import LeadsComponent from './pages/leads/leads-component/leads-component';
import { LeadDetailsPage } from './pages/leads/lead-details-page/lead-details-page';
import Tasks from './pages/Tasks';
import History from './pages/history/history-component/history-component';
import HistoryDetailsComponent from './pages/history/history-details/history-details-component';
import CatalogComponent from './pages/catalog/catalog-component/catalog-component';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import { BusinessesComponent } from './pages/businesses/businesses-component';
import BusinessDetailsComponent from './pages/businesses/business-details/business-details-component';
import AccountSettings from './pages/account/AccountSettings';
import AnalyticsComponent from './pages/analytics/analytics-component';
import CRMPage from './pages/crm';
import Payments from './pages/payments/Payments';
import Clients from './pages/clients/Clients';
import { ClientEntries } from './pages/clients/ClientEntries';

const App: React.FC = () => {
    return (
        <Router>
            <AuthProvider>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route
                        path="/account"
                        element={
                            <ProtectedRoute>
                                <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
                                    <Navbar />
                                    <Box component="main" sx={{ pt: 8 }}>
                                        <AccountSettings />
                                    </Box>
                                </Box>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/search"
                        element={
                            <ProtectedRoute>
                                <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
                                    <Navbar />
                                    <Box component="main" sx={{ pt: 8 }}>
                                        <SearchComponent />
                                    </Box>
                                </Box>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/leads"
                        element={
                            <ProtectedRoute>
                                <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
                                    <Navbar />
                                    <Box component="main" sx={{ pt: 8 }}>
                                        <LeadsComponent />
                                    </Box>
                                </Box>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/leads/lead/:leadId"
                        element={
                            <ProtectedRoute>
                                <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
                                    <Navbar />
                                    <Box component="main" sx={{ pt: 8 }}>
                                        <LeadDetailsPage />
                                    </Box>
                                </Box>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/tasks"
                        element={
                            <ProtectedRoute>
                                <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
                                    <Navbar />
                                    <Box component="main" sx={{ pt: 8 }}>
                                        <Tasks />
                                    </Box>
                                </Box>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/history"
                        element={
                            <ProtectedRoute>
                                <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
                                    <Navbar />
                                    <Box component="main" sx={{ pt: 8 }}>
                                        <History />
                                    </Box>
                                </Box>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/history/:id"
                        element={
                            <ProtectedRoute>
                                <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
                                    <Navbar />
                                    <Box component="main" sx={{ pt: 8 }}>
                                        <HistoryDetailsComponent />
                                    </Box>
                                </Box>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/catalog"
                        element={
                            <ProtectedRoute>
                                <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
                                    <Navbar />
                                    <Box component="main" sx={{ pt: 8 }}>
                                        <CatalogComponent />
                                    </Box>
                                </Box>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/reports"
                        element={
                            <ProtectedRoute>
                                <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
                                    <Navbar />
                                    <Box component="main" sx={{ pt: 8 }}>
                                        <Reports />
                                    </Box>
                                </Box>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/settings"
                        element={
                            <ProtectedRoute>
                                <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
                                    <Navbar />
                                    <Box component="main" sx={{ pt: 8 }}>
                                        <Settings />
                                    </Box>
                                </Box>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/businesses"
                        element={
                            <ProtectedRoute>
                                <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
                                    <Navbar />
                                    <Box component="main" sx={{ pt: 8 }}>
                                        <BusinessesComponent />
                                    </Box>
                                </Box>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/businesses/:id"
                        element={
                            <ProtectedRoute>
                                <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
                                    <Navbar />
                                    <Box component="main" sx={{ pt: 8 }}>
                                        <BusinessDetailsComponent />
                                    </Box>
                                </Box>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/analytics"
                        element={
                            <ProtectedRoute>
                                <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
                                    <Navbar />
                                    <Box component="main" sx={{ pt: 8 }}>
                                        <AnalyticsComponent />
                                    </Box>
                                </Box>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/crm/*"
                        element={
                            <ProtectedRoute>
                                <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
                                    <Navbar />
                                    <Box component="main" sx={{ pt: 8 }}>
                                        <CRMPage />
                                    </Box>
                                </Box>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/payments"
                        element={
                            <ProtectedRoute>
                                <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
                                    <Navbar />
                                    <Box component="main" sx={{ pt: 8 }}>
                                        <Payments />
                                    </Box>
                                </Box>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/clients/*"
                        element={
                            <ProtectedRoute>
                                <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
                                    <Navbar />
                                    <Box component="main" sx={{ pt: 8 }}>
                                        <Clients />
                                    </Box>
                                </Box>
                            </ProtectedRoute>
                        }
                    />
                    <Route path="/clients/:clientId/entries" element={<ClientEntries />} />
                    <Route path="/" element={<Navigate to="/search" replace />} />
                </Routes>
            </AuthProvider>
        </Router>
    );
};

export default App;
